import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

export const getErrorMessage = (field: FieldError | Merge<FieldError, FieldErrorsImpl<any>>) => {
  if (typeof field.message === 'string') {
    return field.message
  }
  return 'Something went wrong!'
}
